
import React, { Component } from "react";
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// action
import { forgetUser, resetForgetPWState } from '../../store/actions';

// import images
import paperPlane from "../../assets/images/paper_plane.png";
import { Stack } from "@mui/material";
// import logodark from "../../assets/images/Aspeed_Logo.svg";
import { Icon } from "@iconify/react/dist/iconify.js";
import LoadingDialog from "../../components/Common/LoadingDialog";
import withRouter from "../../components/Common/withRouter";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";
import Notification from "../../components/Common/Notification";

class ForgetPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false, email: '', emailSent: false, resetPassword: false, showPWRe: false, showPw: false, resetPwSent: false,
            notification: {
                open: false,
                msg: "",
                type: "success",
            }
        };

        // handleValidSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
        this.handleResend = this.handleResend.bind(this);
        this.props.resetForgetPWState();
    }

    componentDidUpdate(prevProps) {
        if (this.props.message !== prevProps.message) {
            const { code, message, errors, data } = this.props.message || {};

            if (code === "success") {
                this.setState({
                    emailSent: true,
                    notification: {
                        open: true,
                        msg: message || "Action successful!",
                        type: "success",
                    }
                });
            } else if (code === "validation_failed") {
                this.setState({
                    notification: {
                        open: true,
                        msg: errors?.email || "Validation failed.",
                        type: "warning",
                    }
                });
            } else if (code === "error") {
                this.setState({
                    notification: {
                        open: true,
                        msg: data?.message || "Validation failed.",
                        type: "warning",
                    }
                });
            }
        }
    }


    // handleValidSubmit
    handleValidSubmit() {
        this.setState({ loading: true });
        const values = {
            email: this.state.email,
        }
        this.props.forgetUser(values);
        this.setState({ loading: false, resetPassword: false });
        // window.location.href = "/password-sent";
    }

    handleResend() {
        this.setState({ loading: false, emailSent: false, resetPassword: false, email: "" });
    }

    handleResetPassword() {
        this.setState({ loading: false, emailSent: false, resetPassword: true });
    }

    handleResetPw() {
        this.setState({ resetPwSent: true });
    }

    handleSubmitEmail = () => {
        if (this.state.email) {
            this.handleValidSubmit()
        }
        else
            this.setState({
                notification: {
                    open: true,
                    msg: "Email field is required",
                    type: "warning",
                }
            })
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <Notification notification={this.state.notification} setNotification={(e) =>
                        this.setState({
                            notification: {
                                open: false,
                                msg: "",
                                type: "success",
                            }
                        })} />
                    <LoadingDialog open={this.props.loading} />
                    <Container fluid className="p-0">
                        <Row className="g-0">
                            <Col lg={12}>
                                <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                    <div className="w-100">
                                        <Row className="justify-content-center">
                                            <Col xs={12} md={8} lg={6} xl={4}>
                                                <div>

                                                    {
                                                        !this.state.emailSent ?
                                                            <>
                                                                <div className="mb-5">
                                                                    <Link to="/login" className="d-flex align-items-center" style={{ fontSize: 14 }}>
                                                                        <i className="ri-arrow-left-s-line font-size-15" style={{ marginRight: 10 }} />Back
                                                                    </Link>
                                                                </div>
                                                                <div className="text-center mb-2 pb-2" style={{ fontSize: 24, fontFamily: 'FunnelSans', fontWeight: 700 }}>Forgot your Password?</div>
                                                                <div className="text-center pb-4" style={{ color: '#717680' }}>Enter the email address associated with your account, and we'll send you a link to reset your password.</div>
                                                                <div className="mt-2">
                                                                    <Stack flexDirection="column" mt={2}>
                                                                        <CustomTextField
                                                                            values={this.state.username}
                                                                            variant="standard"
                                                                            title={'Email'}
                                                                            error={this.props.message?.errors?.email}
                                                                            onChange={(e) => this.setState({ email: e })}
                                                                            style={{ backgroundColor: 'white' }}
                                                                            placeholder='Enter your email'
                                                                        />
                                                                    </Stack>
                                                                    <div className="mt-4 text-center">
                                                                        <CustomButton
                                                                            title={this.props.loading ? "Loading..." : "Send Reset Email"}
                                                                            disabled={this.props.loading}
                                                                            backgroundColor={'var(--bs-theme-color-2)'}
                                                                            textColor={'white'}
                                                                            width={'100%'}
                                                                            borderRadius={8}
                                                                            hoverColor="white"
                                                                            hoverBackgroundColor={"black"}
                                                                            press={() => this.handleSubmitEmail()}
                                                                        />
                                                                    </div>
                                                                    {/* <div className="mt-4 text-center">
                                                                        <Link to="/login" className="clickable-text" style={{ fontSize: 18, color: "#525252" }}> Back to Login</Link>
                                                                    </div> */}
                                                                </div>
                                                            </>
                                                            :
                                                            // check email
                                                            <>
                                                                <div className="text-center mb-2 pb-2" >
                                                                    <img src={paperPlane} alt="" height="64" className="" />
                                                                </div>
                                                                <div className="text-center mb-2 pb-2" style={{ fontSize: 24, fontFamily: 'FunnelSans', fontWeight: 600 }}>Link sent, check your inbox!</div>
                                                                <div className="pb-4" style={{color: '#717680'}}>A link was sent to <span style={{fontFamily: 'FunnelSans-Bold', color: '#1D1B1B'}}>{this.state.email}</span> to reset your password. If you don’t see it, remember to check your spam folder.</div>
                                                                <div className="mt-2">
                                                                    <div className="mt-4 text-center">
                                                                        <CustomButton
                                                                            title={this.props.loading ? "Loading..." : "Back to login"}
                                                                            disabled={this.props.loading}
                                                                            backgroundColor={'var(--bs-theme-color-2)'}
                                                                            textColor={'white'}
                                                                            width={'100%'}
                                                                            borderRadius={8}
                                                                            hoverColor="white"
                                                                            hoverBackgroundColor={"black"}
                                                                            press={() => window.location.href = "/login"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                    }
                                                </div>

                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            {/* <Col lg={8}>
                                <div className="authentication-bg">
                                    <div className="bg-overlay"></div>
                                </div>
                            </Col> */}
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { message, forgetError, loading } = state.Forget;
    return { message, forgetError, loading };
}

export default withRouter(
    connect(mapStatetoProps, { forgetUser, resetForgetPWState })(ForgetPasswordPage)
);
